import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export class SidebarNavTitle extends Vue {
    @Prop({ type: String, required: true })
    readonly label!: string;

    private visibleChildren = false;

    mounted(): void {
        this.refreshVisibleChildren();
    }

    updated(): void {
        this.refreshVisibleChildren();
    }

    private refreshVisibleChildren(): void {
        const next = this.computeHasVisibleChildren();
        if (next !== this.visibleChildren) {
            this.visibleChildren = next;
        }
    }

    get hasVisibleChildren(): boolean {
        void ((this as any).$permissionsVersion ?? 0);
        return this.visibleChildren;
    }

    private computeHasVisibleChildren(): boolean {
        const nodes = this.$slots.default ?? [];
        const slotChildren = nodes
            .map((node: any) => node?.componentInstance)
            .filter(Boolean);
        const children = slotChildren.length ? slotChildren : this.$children ?? [];
        if (children.length === 0) {
            return nodes.some((node) => Boolean(node && (node as any).tag));
        }

        return children.some((child: any) => {
            if (typeof child?.isHidden === "boolean") {
                return !child.isHidden;
            }
            const classes = child?.itemClasses ?? {};
            const hidden =
                classes["blocked-prod"] ||
                classes["invalid-prod"] ||
                classes["blocked-dev"] ||
                classes["invalid-dev"] ||
                classes.blocked ||
                classes.invalid;
            return !hidden;
        });
    }
}
export default SidebarNavTitle;
